import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Injectable, Inject, AfterViewInit, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommandService, ActionCommand } from '../../../../services/action-command.service';

export interface PaymentData {
  method: string;
  amount: number;
}

@Injectable()
@Component({
  selector: 'app-payment-amount-input',
  imports: [CommonModule, FormsModule],
  templateUrl: './payment-amount-input.component.html'
})
export class PaymentAmountInputComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges, ActionCommand {
  
  @Input() paymentMethod: string = '';
  @Input() maxAmount: number = 0;
  @Output() paymentCompleted = new EventEmitter<PaymentData>();
  @Output() cancel = new EventEmitter<void>();
  
  @ViewChild('amountInput', { static: false }) amountInput!: ElementRef<HTMLInputElement>;
  
  paymentAmount: number = 0;

  constructor(
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
    // Inicializar com o valor restante
    this.paymentAmount = this.maxAmount;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Quando maxAmount mudar, atualizar o valor inicial
    if (changes['maxAmount'] && !changes['maxAmount'].firstChange) {
      this.paymentAmount = this.maxAmount;
    }
  }

  ngAfterViewInit(): void {
    // Focar no input após a view ser inicializada
    setTimeout(() => {
      if (this.amountInput) {
        this.amountInput.nativeElement.focus();
        this.amountInput.nativeElement.select();
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    // Registrar comando F1 para confirmar
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.confirm(),
      getDescription: () => 'Confirmar Pagamento'
    });

    // Registrar comando ESC para cancelar
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.cancelPayment(),
      getDescription: () => 'Cancelar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ESC');
  }

  onAmountChange(): void {
    // Validação adicional se necessário
  }

  getPaymentMethodName(): string {
    const methodNames: { [key: string]: string } = {
      'MONEY': 'Dinheiro',
      'PIX': 'PIX',
      'CREDIT_CARD': 'Cartão de Crédito',
      'DEBIT_CARD': 'Cartão de Débito',
      'CHECK': 'Cheque',
      'CREDIT': 'Crédito',
      'BANK_TRANSFER': 'Transferência Bancária',
      'VOUCHER': 'Vale'
    };
    return methodNames[this.paymentMethod] || this.paymentMethod;
  }

  confirm(): void {
    if (this.paymentAmount > 0) {
      const payment: PaymentData = {
        method: this.paymentMethod,
        amount: this.paymentAmount
      };
      this.paymentCompleted.emit(payment);
    }
  }

  cancelPayment(): void {
    this.cancel.emit();
  }

  // Implementação da interface ActionCommand
  getKey(): string {
    return 'F1';
  }

  execute(): void {
    this.confirm();
  }

  getDescription(): string {
    return 'Confirmar Pagamento';
  }
}
